"use strict";

require("core-js/modules/es6.object.assign");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .st0 {\n    fill: url(#SVGID_1_);\n  }\n  .st1 {\n    opacity: 0.67;\n    fill: url(#SVGID_2_);\n  }\n  .st2 {\n    fill: url(#SVGID_3_);\n  }\n  .st3 {\n    fill: url(#SVGID_4_);\n  }\n  .st4 {\n    fill: url(#SVGID_5_);\n  }\n  .st5 {\n    fill: url(#SVGID_6_);\n  }\n  .st6 {\n    opacity: 0.67;\n    fill: url(#SVGID_7_);\n  }\n  .st7 {\n    fill: url(#SVGID_8_);\n  }\n  .st8 {\n    fill: url(#SVGID_9_);\n  }\n  .st9 {\n    fill: url(#SVGID_10_);\n  }\n  .st10 {\n    fill: url(#SVGID_11_);\n  }\n  .st11 {\n    fill: url(#SVGID_12_);\n  }\n  .st12 {\n    opacity: 0.53;\n    fill: url(#SVGID_13_);\n  }\n  .st13 {\n    opacity: 0.53;\n    fill: url(#SVGID_14_);\n  }\n  .st14 {\n    fill: url(#SVGID_15_);\n  }\n  .st15 {\n    fill: url(#SVGID_16_);\n  }\n  .st16 {\n    fill: url(#SVGID_17_);\n  }\n  .st17 {\n    fill: url(#SVGID_18_);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = require("styled-components");

var common_1 = __importDefault(require("../common"));

var style = styled_components_1.css(_templateObject());
/**
 * Firefox Icon
 *
 * @param {Object} props
 * @param {boolean} props.colored // sets brand color instead of currentColor
 */

var Firefox = function Firefox(_a) {
  var _a$colored = _a.colored,
      colored = _a$colored === void 0 ? false : _a$colored,
      rest = __rest(_a, ["colored"]);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "firefox",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500"
  }, rest), colored && react_1["default"].createElement("style", {
    type: "text/css"
  }, style), react_1["default"].createElement("g", null, react_1["default"].createElement("radialGradient", {
    id: "SVGID_1_",
    cx: "-1170.9889",
    cy: "-390.199",
    r: "7.920176e-04",
    gradientTransform: "matrix(1 0 0 1 1258.4413 532.8896)",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "0",
    style: {
      stopColor: "#FFF44F"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2949",
    style: {
      stopColor: "#FF980E"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.4315",
    style: {
      stopColor: "#FF5D36"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.5302",
    style: {
      stopColor: "#FF3750"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.7493",
    style: {
      stopColor: "#F5156C"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.7648",
    style: {
      stopColor: "#F1136E"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.8801",
    style: {
      stopColor: "#DA057A"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.9528",
    style: {
      stopColor: "#D2007F"
    }
  })), react_1["default"].createElement("path", {
    className: "st0",
    d: "M87.5,142.7L87.5,142.7L87.5,142.7z"
  }), react_1["default"].createElement("radialGradient", {
    id: "SVGID_2_",
    cx: "-1170.9895",
    cy: "-390.199",
    r: "4.680987e-04",
    gradientTransform: "matrix(1 0 0 1 1258.4413 532.8896)",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "0",
    style: {
      stopColor: "#B5007F"
    }
  }), react_1["default"].createElement("stop", {
    offset: "1",
    style: {
      stopColor: "#F5156C",
      stopOpacity: 0
    }
  })), react_1["default"].createElement("path", {
    className: "st1",
    d: "M87.5,142.7L87.5,142.7L87.5,142.7z"
  }), react_1["default"].createElement("radialGradient", {
    id: "SVGID_3_",
    cx: "-1170.9889",
    cy: "-390.1991",
    r: "9.300706e-04",
    fx: "-1170.9889",
    fy: "-390.1991",
    gradientTransform: "matrix(1 0 0 1 1258.4413 532.8896)",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "0",
    style: {
      stopColor: "#FFDD00",
      stopOpacity: 0.6
    }
  }), react_1["default"].createElement("stop", {
    offset: "8.366717e-02",
    style: {
      stopColor: "#FFD801",
      stopOpacity: 0.5244
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.1822",
    style: {
      stopColor: "#FECA05",
      stopOpacity: 0.4353
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2884",
    style: {
      stopColor: "#FEB20C",
      stopOpacity: 0.3394
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.3998",
    style: {
      stopColor: "#FD9115",
      stopOpacity: 0.2388
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.5154",
    style: {
      stopColor: "#FB6621",
      stopOpacity: 0.1343
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.6329",
    style: {
      stopColor: "#F9332F",
      stopOpacity: 2.816397e-2
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.664",
    style: {
      stopColor: "#F92433",
      stopOpacity: 0
    }
  })), react_1["default"].createElement("path", {
    className: "st2",
    d: "M87.5,142.7L87.5,142.7L87.5,142.7z"
  })), react_1["default"].createElement("g", null, react_1["default"].createElement("radialGradient", {
    id: "SVGID_4_",
    cx: "87.4522",
    cy: "142.6908",
    r: "1.198354e-03",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "0.1528",
    style: {
      stopColor: "#960E18"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2061",
    style: {
      stopColor: "#CC2335",
      stopOpacity: 0.5541
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2495",
    style: {
      stopColor: "#F13148",
      stopOpacity: 0.1914
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2724",
    style: {
      stopColor: "#FF3750",
      stopOpacity: 0
    }
  })), react_1["default"].createElement("path", {
    className: "st3",
    d: "M87.5,142.7L87.5,142.7L87.5,142.7z"
  }), react_1["default"].createElement("radialGradient", {
    id: "SVGID_5_",
    cx: "87.4521",
    cy: "142.6908",
    r: "1.198084e-03",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "0.1129",
    style: {
      stopColor: "#960E18"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.1893",
    style: {
      stopColor: "#CC2335",
      stopOpacity: 0.5541
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2515",
    style: {
      stopColor: "#F13148",
      stopOpacity: 0.1914
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2843",
    style: {
      stopColor: "#FF3750",
      stopOpacity: 0
    }
  })), react_1["default"].createElement("path", {
    className: "st4",
    d: "M87.5,142.7L87.5,142.7L87.5,142.7z"
  })), react_1["default"].createElement("g", null, react_1["default"].createElement("radialGradient", {
    id: "SVGID_6_",
    cx: "-845.4828",
    cy: "-409.4817",
    r: "467.0826",
    fx: "-828.7765",
    fy: "-417.7389",
    gradientTransform: "matrix(1 0 0 1 1258.4413 532.8896)",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "0",
    style: {
      stopColor: "#FFF44F"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2949",
    style: {
      stopColor: "#FF980E"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.4315",
    style: {
      stopColor: "#FF5D36"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.5302",
    style: {
      stopColor: "#FF3750"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.7493",
    style: {
      stopColor: "#F5156C"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.7648",
    style: {
      stopColor: "#F1136E"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.8801",
    style: {
      stopColor: "#DA057A"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.9528",
    style: {
      stopColor: "#D2007F"
    }
  })), react_1["default"].createElement("path", {
    className: "st5",
    d: "M415.1,124.7c-15.9-20.9-35.4-38.1-57.3-51.2c-1-0.6-2.3-0.4-3.2,0.4c0,0,0,0,0,0c-1.2,1.2-0.9,3.1,0.4,4\n\t\tc40.6,26.3,71.9,68.7,79.2,125.3c15,115-65.3,211-178.3,211.3C131.7,414.9,56.1,305.1,75.9,206.5c1-4.9,0.5-9.7,2.1-14.4\n\t\tc0.9-17.3,7.5-44.5,21.7-72.3c-14.3,7.4-32.5,30.8-41.5,52.4c-13,31.2-17.5,68.5-13.4,104c0.3,2.7,0.6,5.3,0.9,8\n\t\tc16.7,97.8,101.9,172.2,204.4,172c114.2-0.2,207.2-93.9,206.6-208.2C456.5,201.8,441,159.1,415.1,124.7z"
  }), react_1["default"].createElement("radialGradient", {
    id: "SVGID_7_",
    cx: "-1180.906",
    cy: "-369.1591",
    r: "269.7695",
    fx: "-1171.2571",
    fy: "-373.9282",
    gradientTransform: "matrix(1 0 0 1 1258.4413 532.8896)",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "0",
    style: {
      stopColor: "#B5007F"
    }
  }), react_1["default"].createElement("stop", {
    offset: "1",
    style: {
      stopColor: "#F5156C",
      stopOpacity: 0
    }
  })), react_1["default"].createElement("path", {
    className: "st6",
    d: "M415.1,124.7c-15.9-20.9-35.4-38.1-57.3-51.2c-1-0.6-2.3-0.4-3.2,0.4c0,0,0,0,0,0c-1.2,1.2-0.9,3.1,0.4,4\n\t\tc40.6,26.3,71.9,68.7,79.2,125.3c15,115-65.3,211-178.3,211.3C131.7,414.9,56.1,305.1,75.9,206.5c1-4.9,0.5-9.7,2.1-14.4\n\t\tc0.9-17.3,7.5-44.5,21.7-72.3c-14.3,7.4-32.5,30.8-41.5,52.4c-13,31.2-17.5,68.5-13.4,104c0.3,2.7,0.6,5.3,0.9,8\n\t\tc16.7,97.8,101.9,172.2,204.4,172c114.2-0.2,207.2-93.9,206.6-208.2C456.5,201.8,441,159.1,415.1,124.7z"
  }), react_1["default"].createElement("radialGradient", {
    id: "SVGID_8_",
    cx: "-805.3765",
    cy: "-411.9805",
    r: "511.6986",
    fx: "-787.0743",
    fy: "-421.0265",
    gradientTransform: "matrix(1 0 0 1 1258.4413 532.8896)",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "0",
    style: {
      stopColor: "#FFDD00",
      stopOpacity: 0.6
    }
  }), react_1["default"].createElement("stop", {
    offset: "8.366717e-02",
    style: {
      stopColor: "#FFD801",
      stopOpacity: 0.5244
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.1822",
    style: {
      stopColor: "#FECA05",
      stopOpacity: 0.4353
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2884",
    style: {
      stopColor: "#FEB20C",
      stopOpacity: 0.3394
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.3998",
    style: {
      stopColor: "#FD9115",
      stopOpacity: 0.2388
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.5154",
    style: {
      stopColor: "#FB6621",
      stopOpacity: 0.1343
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.6329",
    style: {
      stopColor: "#F9332F",
      stopOpacity: 2.816397e-2
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.664",
    style: {
      stopColor: "#F92433",
      stopOpacity: 0
    }
  })), react_1["default"].createElement("path", {
    className: "st7",
    d: "M415.1,124.7c-15.9-20.9-35.4-38.1-57.3-51.2c-1-0.6-2.3-0.4-3.2,0.4c0,0,0,0,0,0c-1.2,1.2-0.9,3.1,0.4,4\n\t\tc40.6,26.3,71.9,68.7,79.2,125.3c15,115-65.3,211-178.3,211.3C131.7,414.9,56.1,305.1,75.9,206.5c1-4.9,0.5-9.7,2.1-14.4\n\t\tc0.9-17.3,7.5-44.5,21.7-72.3c-14.3,7.4-32.5,30.8-41.5,52.4c-13,31.2-17.5,68.5-13.4,104c0.3,2.7,0.6,5.3,0.9,8\n\t\tc16.7,97.8,101.9,172.2,204.4,172c114.2-0.2,207.2-93.9,206.6-208.2C456.5,201.8,441,159.1,415.1,124.7z"
  })), react_1["default"].createElement("g", null, react_1["default"].createElement("radialGradient", {
    id: "SVGID_9_",
    cx: "-996.6329",
    cy: "-246.6084",
    r: "687.4905",
    gradientTransform: "matrix(1 0 0 1 1258.4413 532.8896)",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "0.1528",
    style: {
      stopColor: "#960E18"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2061",
    style: {
      stopColor: "#CC2335",
      stopOpacity: 0.5541
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2495",
    style: {
      stopColor: "#F13148",
      stopOpacity: 0.1914
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2724",
    style: {
      stopColor: "#FF3750",
      stopOpacity: 0
    }
  })), react_1["default"].createElement("path", {
    className: "st8",
    d: "M415.1,124.7c-15.9-20.9-35.4-38.1-57.3-51.2c-1-0.6-2.3-0.4-3.2,0.4c0,0,0,0,0,0c-1.2,1.2-0.9,3.1,0.4,4\n\t\tc40.6,26.3,71.9,68.7,79.2,125.3c15,115-65.3,211-178.3,211.3C131.7,414.9,56.1,305.1,75.9,206.5c1-4.9,0.5-9.7,2.1-14.4\n\t\tc0.9-17.3,7.5-44.5,21.7-72.3c-14.3,7.4-32.5,30.8-41.5,52.4c-13,31.2-17.5,68.5-13.4,104c0.3,2.7,0.6,5.3,0.9,8\n\t\tc16.7,97.8,101.9,172.2,204.4,172c114.2-0.2,207.2-93.9,206.6-208.2C456.5,201.8,441,159.1,415.1,124.7z"
  }), react_1["default"].createElement("radialGradient", {
    id: "SVGID_10_",
    cx: "-1050.4161",
    cy: "-254.909",
    r: "692.2778",
    gradientTransform: "matrix(1 0 0 1 1258.4413 532.8896)",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "0.1129",
    style: {
      stopColor: "#960E18"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.1893",
    style: {
      stopColor: "#CC2335",
      stopOpacity: 0.5541
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2515",
    style: {
      stopColor: "#F13148",
      stopOpacity: 0.1914
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2843",
    style: {
      stopColor: "#FF3750",
      stopOpacity: 0
    }
  })), react_1["default"].createElement("path", {
    className: "st9",
    d: "M415.1,124.7c-15.9-20.9-35.4-38.1-57.3-51.2c-1-0.6-2.3-0.4-3.2,0.4c0,0,0,0,0,0c-1.2,1.2-0.9,3.1,0.4,4\n\t\tc40.6,26.3,71.9,68.7,79.2,125.3c15,115-65.3,211-178.3,211.3C131.7,414.9,56.1,305.1,75.9,206.5c1-4.9,0.5-9.7,2.1-14.4\n\t\tc0.9-17.3,7.5-44.5,21.7-72.3c-14.3,7.4-32.5,30.8-41.5,52.4c-13,31.2-17.5,68.5-13.4,104c0.3,2.7,0.6,5.3,0.9,8\n\t\tc16.7,97.8,101.9,172.2,204.4,172c114.2-0.2,207.2-93.9,206.6-208.2C456.5,201.8,441,159.1,415.1,124.7z"
  })), react_1["default"].createElement("g", null, react_1["default"].createElement("radialGradient", {
    id: "SVGID_11_",
    cx: "-946.4911",
    cy: "24.7873",
    r: "453.6714",
    fx: "-930.2645",
    fy: "16.7671",
    gradientTransform: "matrix(0.9589 0 0 0.9589 1310.671 86.1109)",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "0",
    style: {
      stopColor: "#FF980E"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.295",
    style: {
      stopColor: "#FF7139"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.4846",
    style: {
      stopColor: "#FF5B51"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.626",
    style: {
      stopColor: "#FF4F5E"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.7365",
    style: {
      stopColor: "#FF4055"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.8428",
    style: {
      stopColor: "#FF3750"
    }
  })), react_1["default"].createElement("path", {
    className: "st10",
    d: "M439.3,197.5c-6.7-60.2-40.5-101.3-83.7-125.3c-7.2-4-16.3-2.3-21.5,4.1l-0.1,0.1c49.2,30.3,80.2,84,81.8,140\n\t\tc1.9,68.1-54,122.4-118.4,125.5c-46.8,2.3-90.9-20.3-112.5-65.6c-4.8-10.1-8.3-20.3-10.1-32.7c-10.2-68.8,36.1-127.5,78.6-142.1\n\t\tc-22.9-20-80.4-18.6-123.1,12.8c-30.8,22.6-50.8,57-57.4,98c-5,31.3-0.3,63.8,12.1,92.8c12.6,29.6,33.1,55.7,59,74.9\n\t\tc28,20.9,61.8,33,96.6,35.6c5.1,0.4,10.3,0.6,15.4,0.6C392.7,416.4,452.1,312.8,439.3,197.5z"
  }), react_1["default"].createElement("radialGradient", {
    id: "SVGID_12_",
    cx: "-946.4911",
    cy: "41.4624",
    r: "430.3706",
    fx: "-931.098",
    fy: "33.8542",
    gradientTransform: "matrix(0.9589 0 0 0.9589 1310.671 86.1109)",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "8.407452e-02",
    style: {
      stopColor: "#FFDE08"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2081",
    style: {
      stopColor: "#FFD609",
      stopOpacity: 0.832
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.4033",
    style: {
      stopColor: "#FFBF0B",
      stopOpacity: 0.5677
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.6437",
    style: {
      stopColor: "#FF9B0F",
      stopOpacity: 0.242
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.8224",
    style: {
      stopColor: "#FF7B12",
      stopOpacity: 0
    }
  })), react_1["default"].createElement("path", {
    className: "st11",
    d: "M439.3,197.5c-6.7-60.2-40.5-101.3-83.7-125.3c-7.2-4-16.3-2.3-21.5,4.1l-0.1,0.1c49.2,30.3,80.2,84,81.8,140\n\t\tc1.9,68.1-54,122.4-118.4,125.5c-46.8,2.3-90.9-20.3-112.5-65.6c-4.8-10.1-8.3-20.3-10.1-32.7c-10.2-68.8,36.1-127.5,78.6-142.1\n\t\tc-22.9-20-80.4-18.6-123.1,12.8c-30.8,22.6-50.8,57-57.4,98c-5,31.3-0.3,63.8,12.1,92.8c12.6,29.6,33.1,55.7,59,74.9\n\t\tc28,20.9,61.8,33,96.6,35.6c5.1,0.4,10.3,0.6,15.4,0.6C392.7,416.4,452.1,312.8,439.3,197.5z"
  })), react_1["default"].createElement("g", null, react_1["default"].createElement("radialGradient", {
    id: "SVGID_13_",
    cx: "-1052.5948",
    cy: "175.2096",
    r: "216.6298",
    gradientTransform: "matrix(0.2371 0.9291 -0.9696 0.2474 720.7849 1188.7325)",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "0.3634",
    style: {
      stopColor: "#FF3750"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.4111",
    style: {
      stopColor: "#FF444B",
      stopOpacity: 0.7895
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.5902",
    style: {
      stopColor: "#FF7139",
      stopOpacity: 0
    }
  })), react_1["default"].createElement("path", {
    className: "st12",
    d: "M439.3,197.5c-6.7-60.2-40.5-101.3-83.7-125.3c-7.2-4-16.3-2.3-21.5,4.1l-0.1,0.1c49.2,30.3,80.2,84,81.8,140\n\t\tc1.9,68.1-54,122.4-118.4,125.5c-46.8,2.3-90.9-20.3-112.5-65.6c-4.8-10.1-8.3-20.3-10.1-32.7c-10.2-68.8,36.1-127.5,78.6-142.1\n\t\tc-22.9-20-80.4-18.6-123.1,12.8c-30.8,22.6-50.8,57-57.4,98c-5,31.3-0.3,63.8,12.1,92.8c12.6,29.6,33.1,55.7,59,74.9\n\t\tc28,20.9,61.8,33,96.6,35.6c5.1,0.4,10.3,0.6,15.4,0.6C392.7,416.4,452.1,312.8,439.3,197.5z"
  }), react_1["default"].createElement("radialGradient", {
    id: "SVGID_14_",
    cx: "-1091.4193",
    cy: "193.0661",
    r: "219.1049",
    gradientTransform: "matrix(0.2371 0.9291 -0.9299 0.2373 702.4121 1239.4639)",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "0.2159",
    style: {
      stopColor: "#FF3750",
      stopOpacity: 0.8
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.2702",
    style: {
      stopColor: "#FF444B",
      stopOpacity: 0.6316
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.4739",
    style: {
      stopColor: "#FF7139",
      stopOpacity: 0
    }
  })), react_1["default"].createElement("path", {
    className: "st13",
    d: "M439.3,197.5c-6.7-60.2-40.5-101.3-83.7-125.3c-7.2-4-16.3-2.3-21.5,4.1l-0.1,0.1c49.2,30.3,80.2,84,81.8,140\n\t\tc1.9,68.1-54,122.4-118.4,125.5c-46.8,2.3-90.9-20.3-112.5-65.6c-4.8-10.1-8.3-20.3-10.1-32.7c-10.2-68.8,36.1-127.5,78.6-142.1\n\t\tc-22.9-20-80.4-18.6-123.1,12.8c-30.8,22.6-50.8,57-57.4,98c-5,31.3-0.3,63.8,12.1,92.8c12.6,29.6,33.1,55.7,59,74.9\n\t\tc28,20.9,61.8,33,96.6,35.6c5.1,0.4,10.3,0.6,15.4,0.6C392.7,416.4,452.1,312.8,439.3,197.5z"
  })), react_1["default"].createElement("g", null, react_1["default"].createElement("radialGradient", {
    id: "SVGID_15_",
    cx: "-854.6896",
    cy: "-27.5692",
    r: "767.539",
    gradientTransform: "matrix(0.9589 0 0 0.9589 1310.671 86.1109)",
    gradientUnits: "userSpaceOnUse"
  }, react_1["default"].createElement("stop", {
    offset: "5.356570e-02",
    style: {
      stopColor: "#FFF44F"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.4573",
    style: {
      stopColor: "#FF980E"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.5211",
    style: {
      stopColor: "#FF8424"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.5871",
    style: {
      stopColor: "#FF7634"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.6393",
    style: {
      stopColor: "#FF7139"
    }
  })), react_1["default"].createElement("path", {
    className: "st14",
    d: "M334.3,76.1c-0.1,0.1-0.1,0.2-0.2,0.3c-5.9,7.3-4.7,17.9,2.5,23.9c31,25.4,51.8,61.5,51.8,103.2\n\t\tc0,57.6-44.6,101.5-96.8,98.4c-77.6-4.7-97.1-84-56.8-118.3c-10.9-2.3-31.3,2.2-45.6,23.5c-12.8,19.1-12.1,48.5-4.2,69.4\n\t\tc21.6,45.2,65.7,68.4,112.5,65.6c88.4-5.4,126.2-78.3,128.6-130.2c2.6-56.3-10.1-106.2-70.3-139.8C348.5,68,339.5,69.7,334.3,76.1z\n\t\t"
  })), react_1["default"].createElement("g", null, react_1["default"].createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: "348.3026",
    y1: "80.1498",
    x2: "137.2952",
    y2: "445.6253"
  }, react_1["default"].createElement("stop", {
    offset: "0",
    style: {
      stopColor: "#FFF44F",
      stopOpacity: 0.8
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.75",
    style: {
      stopColor: "#FFF44F",
      stopOpacity: 0
    }
  })), react_1["default"].createElement("path", {
    className: "st15",
    d: "M415.1,124.7c-5.5-7.3-11.6-14.1-18-20.5c-5.1-5.4-10.6-10.4-16.4-15.1c3.3,2.9,6.5,6,9.6,9.2\n\t\tc11.2,12.1,20.1,26.4,25.2,42c10.8,32.6,10.1,73.5-10.5,105.5c-24.6,38.2-64.6,57.1-107.8,56.2c-1.9,0-3.7,0-5.6-0.1\n\t\tc-77.6-4.7-97.1-84-56.8-118.3c-10.9-2.3-31.3,2.2-45.6,23.5c-12.8,19.1-12.1,48.5-4.2,69.4c-4.8-10.1-8.3-20.3-10.1-32.7\n\t\tc-10.2-68.8,36.1-127.5,78.6-142.1c-22.9-20-80.4-18.6-123.1,12.8c-24.9,18.3-42.7,44.3-52.1,75.3c1.4-17.4,8-43.3,21.5-69.9\n\t\tc-14.3,7.4-32.5,30.8-41.5,52.4c-13,31.2-17.5,68.5-13.4,104c0.3,2.7,0.6,5.3,0.9,8c16.6,97.6,101.7,172,204,172\n\t\tc114.3,0,207-92.7,207-207C456.7,202.5,441.2,159.4,415.1,124.7z"
  })), react_1["default"].createElement("g", null, react_1["default"].createElement("g", null, react_1["default"].createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: "-977.3174",
    y1: "-229.6795",
    x2: "-977.3174",
    y2: "-486.5102",
    gradientTransform: "matrix(1 0 0 1 1258.4413 532.8896)"
  }, react_1["default"].createElement("stop", {
    offset: "0",
    style: {
      stopColor: "#3A8EE6"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.1016",
    style: {
      stopColor: "#4D82EB"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.3885",
    style: {
      stopColor: "#7D65FA"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.5309",
    style: {
      stopColor: "#9059FF"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.6915",
    style: {
      stopColor: "#9D50F8"
    }
  }), react_1["default"].createElement("stop", {
    offset: "0.9888",
    style: {
      stopColor: "#C03AE7"
    }
  }), react_1["default"].createElement("stop", {
    offset: "1",
    style: {
      stopColor: "#C139E6"
    }
  })), react_1["default"].createElement("path", {
    className: "st16",
    d: "M415.5,140.3c-5.2-15.6-14-29.9-25.2-42C366.3,72.5,331,56,297,48.5c-28.6-6.3-58.6-6.2-85.6-0.5\n\t\t\tc-29.4,6.2-55.2,18.9-71.5,34.7c56.4-33,132.4-26.9,184.4,10.1c8.7,6.2,16.8,13.3,24.1,21.1c34.6,37.3,48.7,99.6,19.6,144.4\n\t\t\tC353.4,281,322,302.2,292.7,302c44.9,2.4,86.8-16.6,112.2-56.1C425.6,213.8,426.3,172.9,415.5,140.3z"
  }))), react_1["default"].createElement("g", null, react_1["default"].createElement("g", null, react_1["default"].createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: "-1022.4846",
    y1: "-495.8481",
    x2: "-882.3673",
    y2: "-253.1578",
    gradientTransform: "matrix(1 0 0 1 1258.4413 532.8896)"
  }, react_1["default"].createElement("stop", {
    offset: "0.8054",
    style: {
      stopColor: "#9059FF",
      stopOpacity: 0
    }
  }), react_1["default"].createElement("stop", {
    offset: "1",
    style: {
      stopColor: "#6E008B",
      stopOpacity: 0.5
    }
  })), react_1["default"].createElement("path", {
    className: "st17",
    d: "M415.5,140.3c-5.2-15.6-14-29.9-25.2-42C366.3,72.5,331,56,297,48.5c-28.6-6.3-58.6-6.2-85.6-0.5\n\t\t\tc-29.4,6.2-55.2,18.9-71.5,34.7c56.4-33,132.4-26.9,184.4,10.1c8.7,6.2,16.8,13.3,24.1,21.1c34.6,37.3,48.7,99.6,19.6,144.4\n\t\t\tC353.4,281,322,302.2,292.7,302c44.9,2.4,86.8-16.6,112.2-56.1C425.6,213.8,426.3,172.9,415.5,140.3z"
  }))));
};

exports["default"] = Firefox;